import {Box, HBox} from '../../../components/core/view';
import {ClientType, getStoreName} from '@buncha/common/types/common';
import {H2Text, H5Text} from '../../../components/core/text';
import React, {useEffect} from 'react';
import {useColorThemeType, useFontTheme} from '../../../appStyles/hooks/theme';

import {Analytics} from '@buncha/config/analytics/analytics';
import BottomSheet from '../../../components/composites/bottomSheet';
import {EventType} from '@buncha/config/analytics/type';
import {MainScreens} from '@buncha/navigation/types';
import {Modules} from '@buncha/utils/types';
import {PButton} from '../../../components/core/Button';
import {Store} from '@buncha/home/types';
import WifiIcon from '@buncha/components/core/icon/WifiIcon';
import font from '../../../appStyles/style/font';
import {styles} from './styles';
import {useGetLocale} from '@buncha/localization/hooks';

interface RecheckBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  selectedStore: Store | undefined;
}

function PromptStoreWifiSheet(props: RecheckBottomSheetProps) {
  const {isOpen, onClose, selectedStore} = props;
  const theme = useColorThemeType();
  const muliFont = useFontTheme('muli');
  const mortiseFont = useFontTheme('mortise');
  const {title, body, button} =
    useGetLocale(Modules.home, MainScreens.Home) ?? {};

  useEffect(() => {
    Analytics.eventWithProps('Connect to Store Wifi', {
      type: EventType.cta,
      client: ClientType.meijer,
      storeType: getStoreName(String(selectedStore?.id)),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStore?.id]);

  return (
    <BottomSheet
      open={isOpen}
      onClose={onClose}
      bgColor={theme?.background.white[100]}>
      <Box style={styles.mainContainer}>
        <HBox style={styles.heading}>
          <WifiIcon height={35} width={30} viewBox="0 4 28 28" />
          <H2Text
            style={[
              styles.headerText,
              {
                color: theme?.text.blue[300],
                fontFamily: mortiseFont[700].normal,
              },
            ]}>
            {title?.storeWifi}
          </H2Text>
        </HBox>
        <H5Text
          style={[
            styles.headerText,
            {
              color: theme?.text.gray[100],
              fontFamily: muliFont[700].normal,
            },
          ]}>
          {body?.connectToWifi}
        </H5Text>
        <PButton
          title={button?.continue}
          style={styles.buttonStyle}
          bgColor={theme?.text.blue[100]}
          titleStyle={{
            ...font.FontSize.fontH3,
            fontFamily: muliFont[700].normal,
          }}
          titleColor={theme?.background.white[100]}
          onPress={onClose}
          borderColor={theme?.background.blue[100]}
          borderWidth={1}
        />
      </Box>
    </BottomSheet>
  );
}

export default React.memo(PromptStoreWifiSheet);
